const QCLOUD_BUCKET_CDN_MAP = {
  evapic: 'evapic-10008268.image.myqcloud.com',
  growth: 'growth-img.xhscdn.com',
  xhsci: 'fe-img-qc.xhscdn.com',
  picasso: 'picasso-static.xiaohongshu.com',
  'picasso-private': 'picasso-private.xiaohongshu.com',
  qimg: 'qimg.xiaohongshu.com',
  redverify: 'redverify-1251524319.image.myqcloud.com',
  themis: 'themis-1251524319.image.myqcloud.com',
  xhsis: 'xhsis-10008268.image.myqcloud.com',
  circle: 'circle.xhscdn.com',
  'user-identity': 'user-identity-1251524319.cos.ap-shanghai.myqcloud.com',
  'ads-image': 'ads-image-1251524319.cos.ap-shanghai.myqcloud.com',
  'ads-video': 'ads-video-1251524319.cos.ap-shanghai.myqcloud.com',
  'club-image': 'club-image-qc.xhscdn.com',
  'club-video': 'club-video-qc.xhscdn.com',
  'xhslive-image': 'xhslive-image.xhscdn.com',
  'capa-cvts': 'capa-image-qc.xhscdn.com',
  'sns-open': 'sns-open-qc.xhscdn.com',
  'finance-public': 'finance.xhscdn.com',
}

const QINIU_BUCKET_CDN_MAP = {
  picasso: {
    cdnDomain: 'fe-video-qc.xhscdn.com',
    bucketDomain: 'picasso-qiniu.xiaohongshu.com',
  },
  'picasso-private': {
    cdnDomain: 'dc-private.xhscdn.com',
    bucketDomain: 'picasso-private-qiniu.xiaohongshu.com',
  },
  bricole: {
    cdnDomain: 'bricole.xiaohongshu.com',
    bucketDomain: 'bricole.xiaohongshu.com',
  },
  'finance-private': {
    cdnDomain: 'finance-pri-qiniu.xiaohongshu.com',
    bucketDomain: 'finance-pri-qiniu.xiaohongshu.com',
  },
  'finance-public': {
    cdnDomain: 'finance-pub-qiniu.xiaohongshu.com',
    bucketDomain: 'finance-pub-qiniu.xiaohongshu.com',
  },
  'fls-themis': {
    cdnDomain: 'themis-static.xiaohongshu.com',
    bucketDomain: 'themis-static.xiaohongshu.com',
  },
  'hey-video': {
    cdnDomain: 'hey-video.xhscdn.com',
    bucketDomain: 'hey-video.xhscdn.com',
  },
  intdoc: {
    cdnDomain: 'poseidon.static.xiaohongshu.com',
    bucketDomain: 'poseidon.static.xiaohongshu.com',
  },
  'merchant-platform': {
    cdnDomain: 'ark-static.xiaohongshu.com',
    bucketDomain: 'ark-static.xiaohongshu.com',
  },
  'note-audio': {
    cdnDomain: 'audio.xhscdn.com',
    bucketDomain: 'audio.xhscdn.com',
  },
  'note-music': {
    cdnDomain: 'music.xhscdn.com',
    bucketDomain: 'music.xhscdn.com',
  },
  'note-video': {
    cdnDomain: 'sns-video-qn.xhscdn.com',
    bucketDomain: 'sns-video-qn.xhscdn.com',
  },
  'note-video-gif': {
    cdnDomain: 'sg.xiaohongshu.com',
    bucketDomain: 'sg.xiaohongshu.com',
  },
  'wx-burn-video': {
    cdnDomain: 'wx-burn-video.xhscdn.com',
    bucketDomain: 'wx-burn-video.xhscdn.com',
  },
  solomon: {
    cdnDomain: 'solomon.xiaohongshu.com',
    bucketDomain: 'solomon.xiaohongshu.com',
  },
  'sns-pages': {
    cdnDomain: 'sp.xiaohongshu.com',
    bucketDomain: 'sp.xiaohongshu.com',
  },
  'sale-item': {
    cdnDomain: 'store.xiaohongshu.com',
    bucketDomain: 'store.xiaohongshu.com',
  },
  'redlab-jihe': {
    cdnDomain: 'lab-static.xiaohongshu.com',
    bucketDomain: 'lab-static.xiaohongshu.com',
  },
  'ads-video-qn': {
    cdnDomain: 'ads-video-qn.xiaohongshu.com',
    bucketDomain: 'ads-video-qn.xiaohongshu.com',
  },
  'club-image-xhs': {
    cdnDomain: 'club-image-qn.xhscdn.com ',
    bucketDomain: 'club-image.xiaohongshu.com',
  },
  'club-video-xhs': {
    cdnDomain: 'club-video-qn.xhscdn.com',
    bucketDomain: 'club-video.xiaohongshu.com',
  },
  'xhslive-video': {
    cdnDomain: 'xhslive-video.xhscdn.com',
    bucketDomain: 'xhslive-video.xhscdn.com',
  },
  'capa-video': {
    cdnDomain: 'capa-video-qn.xhscdn.com',
    bucketDomain: 'capa-video-qn.xhscdn.com',
  },
}

const PROD_HOST = 'https://www.xiaohongshu.com'
const RED_IMAGE_PROD_HOST = '//redimage.xiaohongshu.com'
const LOGAN_HOST = 'https://logan.devops.xiaohongshu.com/proxy/uploader'
const QCLOUD_SIGN = '/fe_common_api/burdock/upload/v4/qcloud/token'
const QINIU_TOKEN = '/fe_common_api/burdock/upload/v4/qiniu/token'
const WATERMARK = '/red/watermark/identity/v1'
const QCLOUD_TMP = '/fe_common_api/burdock/upload/v3/qcloud/private/tmp_url'
const ORIGINAL_IMAGE_DIR = 'original_user_identity_image' // 未打水印的原图存储的目录，不允许使用，并会被清理
const ORIGINAL_TMP_IMAGE_DIR = 'identity_tmp' // 下载时需打二次水印，用于临时存储，定时清理
const CONTENT_TYPE = {
  HTML: 'text/html', // html 格式
  PLAIN: 'text/plain', // 纯文本格式
  XML: 'text/xml', // xml
  GIF: 'image/gif',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  PDF: 'application/pdf', // pdf
  JSON: 'application/json', // json
  WORLD: 'application/msword', // world
  STREAM: 'application/octet-stream', // stream
}

export {
  QCLOUD_BUCKET_CDN_MAP,
  QINIU_BUCKET_CDN_MAP,
  PROD_HOST,
  LOGAN_HOST,
  RED_IMAGE_PROD_HOST,
  WATERMARK,
  ORIGINAL_IMAGE_DIR,
  ORIGINAL_TMP_IMAGE_DIR,
  QCLOUD_TMP,
  QCLOUD_SIGN,
  QINIU_TOKEN,
  CONTENT_TYPE,
}
